import { createApp } from "vue";
import PlanMap from "./PlanMap.vue";
import store from "./store/store";

if (document.querySelector('#plan_map')) {
  const app = createApp(PlanMap)
  app.use(store)
  app.mount('#plan_map')
}
